import {
  columnFacetingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  createFacetedRowModel,
  createFacetedUniqueValues,
  createFilteredRowModel,
  createPaginatedRowModel,
  createSortedRowModel,
  globalFilteringFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_basic,
  sortFn_datetime,
  sortFn_text,
  tableFeatures,
} from "@tanstack/react-table";

/**
 * The single feature set every listing in this app shares. TanStack Table v9
 * only ships the features you register, so this is the one place that decides
 * what a `<DataTable/>` can do: filter, facet, sort, paginate, hide columns and
 * select rows.
 */
export const dataTableFeatures = tableFeatures({
  columnFacetingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  globalFilteringFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  facetedRowModel: createFacetedRowModel(),
  facetedUniqueValues: createFacetedUniqueValues(),
  filteredRowModel: createFilteredRowModel(),
  paginatedRowModel: createPaginatedRowModel(),
  sortedRowModel: createSortedRowModel(),
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    basic: sortFn_basic,
    datetime: sortFn_datetime,
    text: sortFn_text,
  },
});

/**
 * Filter function behind the faceted checkbox dropdowns: keep the row when its
 * value is one of the checked values. An empty selection means "no filter".
 * `<DataTable/>` attaches this to every faceted column automatically.
 */
export const facetFilterFn = (row, columnId, filterValue) => {
  if (!filterValue || filterValue.length === 0) return true;
  return filterValue.includes(facetValue(row.getValue(columnId)));
};

/** Facets are compared as strings so `1`/`"1"` and null/"" do not split a bucket. */
export const facetValue = (value) =>
  value === null || value === undefined ? "" : String(value);
